import React from 'react'
import { Button, Tooltip } from '@mui/material'
import RefreshIcon from '@mui/icons-material/Refresh'

export interface RefreshButtonProps {
  onClick: () => void
  disabled?: boolean
  title?: string
}

const RefreshButton: React.FC<RefreshButtonProps & { showText?: boolean }> = ({
  onClick,
  disabled = false,
  title = 'Atualizar',
  showText = false,
}) => (
  <Tooltip title={title}>
    <Button
      variant="contained"
      size="medium"
      startIcon={<RefreshIcon />}
      onClick={onClick}
      disabled={disabled}
      aria-label={title}
      sx={{ minWidth: showText ? 'auto' : 40, px: showText ? 2 : 1 }}
    >
      {showText && title}
    </Button>
  </Tooltip>
)

export default RefreshButton
